<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>
								{{ this.$vuetify.lang.t('$vuetify.front.items.riordino') }}
							</v-toolbar-title>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->

								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text>
											<v-icon>mdi-arrow-collapse-down</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item
											@click="exportAsync('items', 'csv', { search: searchfield, categories: settings.filters.categories, brands: settings.filters.brand, suppliers: settings.filters.suppliers, selected: selected, riordino: true })"
										>
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in CSV</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item
											@click="exportAsync('items', 'excel', { search: searchfield, categories: settings.filters.categories, brands: settings.filters.brand, suppliers: settings.filters.suppliers, selected: selected, riordino: true })"
										>
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Esporta in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item
											@click="exportAsync('items', 'excelSingolo', { search: searchfield, categories: settings.filters.categories, brands: settings.filters.brand, suppliers: settings.filters.suppliers, selected: selected, riordino: true })"
										>
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Esporta unica variante in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete
										v-model="settings.filters.brand"
										:menu-props="{ closeOnContentClick: true }"
										:items="brands"
										outlined
										label="Brand"
										item-value="_id"
										multiple
										item-text="trans.name"
										clearable
										dense
										:search-input.sync="search"
										@change="clearSearchInput"
										hide-details
									></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete
										outlined
										v-model="settings.filters.categories"
										:menu-props="{ closeOnContentClick: true }"
										multiple
										:items="listcategories"
										label="Categorie"
										item-value="_id"
										item-text="string"
										clearable
										dense
										:search-input.sync="search"
										@change="clearSearchInput"
										hide-details
									>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete
										outlined
										v-model="settings.filters.suppliers"
										:menu-props="{ closeOnContentClick: true }"
										:items="suppliers"
										label="Fornitore"
										item-value="_id"
										multiple
										item-text="Company"
										clearable
										dense
										:search-input.sync="search"
										@change="clearSearchInput"
										hide-details
									></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.color"
										outlined
										:menu-props="{ closeOnContentClick: true }"
										:items="selectColor"
										label="Tags"
										multiple
										clearable
										prepend-inner-icon="mdi-tag"
										dense
										:search-input.sync="search"
										@change="clearSearchInput"
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.images"
										outlined
										:menu-props="{ closeOnContentClick: true }"
										:items="options"
										label="Immagini presenti"
										item-value="value"
										item-text="text"
										clearable
										dense
										:search-input.sync="search"
										@change="clearSearchInput"
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="editItem(null)" v-if="selected.length === 1"> modifica </v-tab>
								<v-tab @click="duplicateItem(null)" v-if="selected.length === 1"> duplica </v-tab>
								<v-tab @click="deleteItem(null)"> elimina </v-tab>

								<!--								<v-tab @click="confirmUpdateFromShopify(null)" v-if="shopify && selected.length === 1"> Aggiorna da Shopify </v-tab>-->
								<v-tab @click="exportAsync('items', 'csv', { search: searchfield, categories: settings.filters.categories, brands: settings.filters.brand, suppliers: settings.filters.suppliers, selected: selected, riordino: true })">
									Download
								</v-tab>
							</v-tabs>
						</v-card>

						<v-data-table
							v-model="selectedall"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							@input="toggle"
							class="elevation-0"
							:mobile-breakpoint="0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							show-select
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="reorder-cards">
									<tr v-for="item in items" :key="item._id + '-' + (item.variants && item.variants._id)">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)" :image="createImage(item) || imagePlaceholder" :image-fallback="imagePlaceholder">
												<template v-slot:title>
													<span v-html="convertSearch((item.trans && item.trans.name) || 'Prodotto')"></span>
												</template>
												<template v-slot:actions>
													<v-checkbox class="mt-0 pt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
													<v-menu offset-y>
														<template v-slot:activator="{ on }">
															<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on" title="Etichetta colore">
																<v-icon small>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item v-for="colore in selectColor" :key="colore">
																<v-btn @click="changeFlag(item, colore)" elevation="0" icon :color="colore"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-menu :transition="false" offset-y close-on-content-click eager>
														<template v-slot:activator="{ on }">
															<v-btn icon small color="primary" v-on="on">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link v-for="menu of menuInline" :key="menu.operation" @click="navigateTo(menu.operation, item)">
																<v-list-item-title class="size9">{{ menu.text }}</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="shopify" @click="updateFromShopify(item)">
																<v-list-item-title class="size9">Aggiorna da Shopify</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div v-if="(item.brand && item.brand.trans && item.brand.trans.name) || marketplaceAttivi(item).length" class="d-flex align-center flex-wrap mb-2">
														<span v-if="item.brand && item.brand.trans && item.brand.trans.name" class="mr-2 reorder-brand">{{ item.brand.trans.name }}</span>
														<a v-for="(market, mi) of marketplaceAttivi(item)" :key="mi" :href="market.url" target="_blank" class="d-inline-flex align-center mr-2">
															<img :src="getImageMarketplace(market.platform)" :alt="market.platform" style="height: 18px" />
															<img :src="getImageFlag(market.country)" :alt="market.country" style="height: 14px; margin-left: 2px" />
														</a>
													</div>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Prodotto attivo</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div v-if="item.variante" class="d-flex align-center justify-space-between mt-1">
													<span class="card-label">Variante attiva</span>
													<v-switch v-model="item.variants.active" @change="changeStatusVariant(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div v-if="(item.categories || []).some(el => el && el.trans && el.trans.name)" class="mt-2">
													<template v-for="(el, ci) of item.categories">
														<v-chip v-if="el && el.trans && el.trans.name" :key="ci" x-small class="mr-1 mb-1">{{ el.trans.name }}</v-chip>
													</template>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="`${item.id}${_.random(1, 10000)}`">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->
										<td>
											<v-checkbox class="mt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
										</td>
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu :transition="false" offset-y close-on-content-click eager>
												<template v-slot:activator="{ on }">
													<v-btn icon dark v-on="on" color="primary" dense>
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link v-for="menu of menuInline" @click="navigateTo(menu.operation, item)">
														<v-list-item-title class="size9">{{ menu.text }}</v-list-item-title>
													</v-list-item>

													<v-list-item link v-if="shopify" @click="updateFromShopify(item)">
														<v-list-item-title class="size9">Aggiorna da Shopify</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
											Item<br />
											<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
											<span v-if="item.variante">
												<p class="mt-4">
													Variant<br />
													<v-switch v-model="item.variants.active" @change="changeStatusVariant(item)" color="primary" class="mt-0" hide-details></v-switch>
												</p>
											</span>
										</td>

										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>
										<td>
											{{ item.updated_at | moment('DD/MM/YYYY') }}
										</td>
										<td>
											<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="createImage(item)" @error="imageUrlAlt(index)"></v-img>

											<!---->
										</td>
										<td>
											<span v-if="item.brand && item.brand.trans">
												{{ item.brand.trans.name }}
											</span>
										</td>
										<td>
											<template v-for="el of item.categories">
												<v-chip v-if="el && el.trans && el.trans.name" small class="ma-1">
													{{ el.trans.name }}
												</v-chip>
											</template>
										</td>
										<td>
											<span v-html="convertSearch(item.model)"></span>
										</td>
										<td v-if="item.trans">
											<span v-html="convertSearch(item.trans.name)"></span>
										</td>
										<td>
											<div v-for="element in item.variants.variants" v-if="item.variante">
												<b>{{ element.name.trans }}</b>

												{{ element.value.trans }}
											</div>
										</td>

										<td>
											<span v-html="convertSearch(item.variants.sku)"></span>
										</td>
										<td>{{ item.supplier.Company }}</td>
										<td>
											<span v-html="convertSearch(item.variants.ean)"></span>
										</td>
										<td>{{ item.variants.qt }}</td>
										<td>{{ item.variants.riarrange }}</td>
										<td>
											<span v-if="item.variants.unit">
												{{ item.variants.unit.trans }}
											</span>
										</td>
										<td>{{ item.variants.buy.toFixed(3) }}</td>
										<td>{{ item.variants.qtunit }}</td>
										<td>{{ item.variants.sell.toFixed(3) }}</td>
										<td>
											<span v-if="item.vat">
												{{ item.vat }}
											</span>
										</td>
										<td>{{ item.variants.pricevat.toFixed(3) }}</td>
										<td>
											<span v-if="item.variants.currency">
												{{ item.variants.currency }}
											</span>
										</td>
										<td>
											<v-chip v-if="item.marketplace.length > 0 && market.status === 'Confirmed'" v-for="(market, index) of item.marketplace" :key="index" class="ma-1">
												<a :href="market.url" target="_blank">
													<v-avatar left>
														<img :src="getImageMarketplace(market.platform)" :alt="market.platform" />
													</v-avatar>
													<v-avatar>
														<img :src="getImageFlag(market.country)" :alt="market.country" />
													</v-avatar>
												</a>
											</v-chip>
										</td>
										<td>
											<v-menu
												:disabled="disabled"
												:absolute="absolute"
												:open-on-hover="openOnHover"
												:close-on-click="closeOnClick"
												:close-on-content-click="closeOnContentClick"
												:offset-x="offsetX"
												:offset-y="offsetY"
											>
												<template v-slot:activator="{ on }">
													<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on">
														<v-icon>mdi-tag</v-icon>
													</v-btn>
												</template>
												<v-list dense>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'red')" elevation="0" icon color="red"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'pink')" elevation="0" icon color="pink"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'purple')" elevation="0" icon color="purple"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'indigo')" elevation="0" icon color="indigo"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'blue')" elevation="0" icon color="blue"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'green')" elevation="0" icon color="green"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'yellow')" elevation="0" icon color="yellow"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'orange')" elevation="0" icon color="orange"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn @click="changeFlag(item, 'grey')" elevation="0" icon color="grey"><v-icon>mdi-tag</v-icon></v-btn>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<!--td>{{ item.id }}</td-->
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :value="getDialog" fullscreen hide-overlay eager transition="dialog-bottom-transition" persistent internal-activator no-click-animation :eager="true" :retain-focus="false">
			<FormDuplicate v-if="operation === 'FormDuplicate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormDuplicate>
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormCreate>
			<ImportShopify v-if="operation === 'ImportShopify'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></ImportShopify>
			<FormFile v-if="operation === 'FormFile'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormFile>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il prodotto non potrai più ripristinarlo. I prodotti associati resteranno senza categoria </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmUpdate" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Importando il prodotto da shopify alcune informazioni potrebbero essere sovrascritte </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmUpdate = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="updateFromShopify"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmImport" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Verranno inseririti tutti i prodotti presenti su shopify che ancora non sono inseriri su AzSeller </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmImport = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="getItemsShopifyAz"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { openWithReturn } from '@/components/core/pageReturn';
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import axios from 'axios';
import { Category } from '../../utils/Category';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
Vue.use(VuetifyDraggableTreeview);

const FormCreate = () => import('@/components/items/Create.vue');
const FormEdit = () => import('@/components/items/Edit.vue');
const FormFile = () => import('@/components/items/File.vue');
const FormDuplicate = () => import('@/components/items/Duplicate.vue');
const ImportShopify = () => import('@/components/items/ImportShopify.vue');

export default {
	name: 'Items',
	data() {
		return {
			menu: false,
			dialogconfirmUpdate: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			listcategories: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					categories: [],
					brand: [],
					variants: [],
					suppliers: [],
					images: '',
					riordino: true,
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			search: '',
			selected: [],
			selectedall: [],
			total: 0,
			totalwarehouse: 0,
			headers: [
				{ text: '', value: '' },
				{ text: 'Status', value: 'is_active', sortable: false },
				{ text: 'Creazione', value: 'created_at', sortable: true },
				{ text: 'Aggiornamento', value: 'updated_at', sortable: true },
				{ text: 'Immagine', value: 'trans.name', sortable: false },
				{ text: 'Brand', value: 'model', sortable: false },
				{ text: 'Categoria', value: 'model', sortable: false },
				{ text: 'Modello', value: 'model' },
				{ text: 'Nome', value: 'trans.name' },
				{ text: 'Variante', value: 'model', sortable: false },
				{ text: 'Sku', value: 'variants.sku' },
				{ text: 'Supplier', value: 'variants.supplier' },
				{ text: 'Ean', value: 'variants.ean' },
				{ text: 'Quantità', value: 'variants.qt' },
				{ text: 'Riordino', value: 'variants.riarrange' },
				{ text: 'Unità', value: 'variants.buy' },
				{ text: 'Prezzo acquisto', value: 'variants.buy' },
				{ text: 'Quantità unità', value: 'variants.qtunit' },
				{ text: 'Prezzo ', value: 'variants.sell' },
				{ text: 'Vat ', value: 'vat' },
				{ text: 'Prezzo + iva', value: 'variants.sell' },
				{ text: 'Valuta', value: 'sell', sortable: false },
				{ text: 'Marketplace', value: 'markeplace', sortable: false },
				{ text: '', value: '', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			options: [
				{ text: '', value: '' },
				{ text: 'si', value: true },
				{ text: 'no', value: false },
			],
			listCategories: [],
			treeCategories: [],
			selectVariants: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			fattureincloud: false,
			langDefault: '',
			brands: [],
			suppliers: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			listValueVariantConvert: [],
			menuInline: [
				{
					operation: 'edit',
					text: 'Modifica',
				},
				{
					operation: 'print',
					text: 'Stampa etichetta',
				},
				{
					operation: 'duplicate',
					text: 'Duplica',
				},
				{
					operation: 'delete',
					text: 'Elimina',
				},
				{
					operation: 'join',
					text: 'Unisci',
				},
			],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);

		this.linkdownload = `${this.getUrl}nocors/items/download`;
		//await this.fetchSetting();
		let promises = [];
		promises.push(this.fetchSetting());
		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));
		promises.push(this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws']));
		const result = await Promise.all(promises);

		const status = result[1];

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
		const category = new Category(this.getSettings.categories, this.langDefault);
		await category.buildTotal();
		await category.refactorCategory();
		await category.createPath();
		await category.dynamicSort();

		this.listcategories = await category.getTree;
		this.selectVariants;

		this.getSettings.variants.forEach(el => {
			const name = el.trans.find(vname => vname.lang === this.langDefault);

			const values = [];
			if (name) {
				el.values.forEach(elvalue => {
					const nameValue = elvalue.trans.find(vvalue => vvalue.lang === this.langDefault);

					if (nameValue && elvalue._id && nameValue.name) {
						values.push({ _id: elvalue._id, name: nameValue.name });
						this.listValueVariantConvert.push({ _id: elvalue._id, name: name.name, value: nameValue.name });
					}
				});
				this.selectVariants.push({ name: name.name, values: values });
			}
		});

		/*const magento = status.find(el => {
			return el.service === 'magento';
		});
		if (magento?.service) {
			this.magento = magento.active;
		}*/

		let shopify = status.find(el => el.service === 'shopify' && el.active === true);

		if (shopify) {
			this.shopify = shopify.active;
		}

		const fattureincloud = status.find(el => {
			return el.service === 'fattureInCloud';
		});
		if (fattureincloud?.service) {
			this.fattureincloud = fattureincloud.active;
		}

		this.fetchSelect({}).then(result => {
			this.brands = result.data;
		});

		this.fetchSupplierSelect({}).then(result => {
			this.suppliers = result.data;
		});
		//await this.getDataFromApi();
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		'settings.options': {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					let outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;

				this.getDataFromApi();
			},
			deep: true,
		},
		'settings.filters': {
			handler: function () {
				console.log('settings.filters');
				this.settings.options.page = 1;
				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormCreate,
		FormEdit,
		FormFile,
		FormDuplicate,
		ImportShopify,
		KeyValueCard,
		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// immagine di ripiego della card quando il prodotto non ha foto o la foto non si carica
		imagePlaceholder() {
			return require('@/assets/images/picture.svg');
		},
		selectedLength() {
			return this.selected.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'items/getIndex',
			getItems: 'items/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'items/getSortBy',
			getSortDesc: 'items/getSortDesc',
			getCategoriesTree: 'categories/getCategoriesTree',
			getCategoriesChildrean: 'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'items/setItems',
			setItem: 'items/setItem',
			setIndex: 'items/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'items/asyncFetchData',
			fetchTotal: 'items/asyncFetchTotalData',
			deleteItems: 'items/deleteItems',

			destroyData: 'items/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			fetchLists: 'brands/fetchLists',
			fetchSelect: 'brands/fetchSelect',
			fetchSupplierSelect: 'suppliers/fetchSelect',
			getItemShopify: 'items/getItemShopify',
			getNewItemShopify: 'items/getNewItemShopify',
			setUpdateStatusItem: 'items/setUpdateStatusItem',
			setUpdateStatusItemVariant: 'items/setUpdateStatusItemVariant',
			updateSingleItemShopify: 'items/updateSingleItemShopify',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',

			//'resetMessages' : 'settings/resetMessages'
		}),
		async getItemsShopifyAz() {
			this.dialogconfirmImport = false;
			this.setPreload(true);
			await this.getItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'I prodotti saranno caricati in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		navigateTo(operation, item) {
			switch (operation) {
				case 'edit':
					this.editItem(item);
					break;
				case 'duplicate':
					this.duplicateItem(item);
					break;
				case 'delete':
					this.deleteItem(item);
					break;
				case 'join':
					this.joinItem(item);
					break;
				case 'print':
					this.printItem(item);
					break;
			}
		},
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				let re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},
		getImageMarketplace(img) {
			let logo = '';

			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		// marketplace confermati, mostrati come loghi nella card da telefono
		marketplaceAttivi(item) {
			return (item.marketplace || []).filter(market => market.status === 'Confirmed');
		},
		// stessi dati delle colonne della tabella desktop, con giacenza e riordino in evidenza
		campiCard(item) {
			const v = item.variants || {};
			const valuta = v.currency || '';
			const numero = value => (value !== undefined && value !== null && value !== '' && !isNaN(Number(value)) ? Number(value).toFixed(3) : '');
			const prezzo = value => (numero(value) ? `${numero(value)} ${valuta}`.trim() : '');
			const variante = item.variante
				? (v.variants || [])
					.map(el => `${(el && el.name && el.name.trans) || ''} ${(el && el.value && el.value.trans) || ''}`.trim())
					.filter(Boolean)
					.join(', ')
				: '';
			const data = value => (value ? this.$moment(value).format('DD/MM/YYYY') : '');
			const campi = [
				{ label: 'SKU', value: v.sku },
				{ label: 'EAN', value: v.ean },
				{ label: 'Modello', value: item.model },
				{ label: 'Fornitore', value: item.supplier && item.supplier.Company },
				{ label: 'Variante', value: variante },
				{ label: 'Qtà', value: v.qt, strong: true },
				{ label: 'Riordino', value: v.riarrange, strong: true },
				{ label: 'Unità', value: v.unit && v.unit.trans },
				{ label: 'Acquisto', value: prezzo(v.buy) },
				{ label: 'Unità per vendita', value: v.qtunit },
				{ label: 'Vendita', value: prezzo(v.sell) },
				{ label: 'IVA', value: item.vat },
				{ label: 'Con IVA', value: prezzo(v.pricevat) },
				{ label: 'Creazione', value: data(item.created_at) },
				{ label: 'Aggiornamento', value: data(item.updated_at) },
			];
			// nella card restano solo le voci valorizzate: il prodotto ha molti campi facoltativi
			return campi.filter(campo => campo.value !== undefined && campo.value !== null && campo.value !== '');
		},
		imageUrlAlt(index) {
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},

		clearSearchInput() {
			this.search = '';
		},

		createImage(item) {
			let image = '';

			if (_.size(item.images) > 0) {
				let first = _.first(item.images);

				if (_.size(first.sizes) > 0) {
					let firstimage = _.first(first.sizes);
					image = firstimage.value;
				}
			}
			let images = item.images;
			// image = require(`@/assets/images/picture.svg`);

			//console.log("i",images)

			if (_.size(item.variants) > 0) {
				_.forEach(item.variants.variants, variant => {
					_.forEach(images, img => {
						if (_.includes(img.variants, _.toString(variant._id))) {
							let first = _.first(img.sizes);
							image = first.value;
							return false;
						}
					});
				});
			}
			try {
				return image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		download() {
			return (
				'nocors/items/download?token=' +
				this.getToken +
				'&search=' +
				this.searchfield +
				'&categories=' +
				this.settings.filters.categories +
				'&brands=' +
				this.settings.filters.brands +
				'&selected=' +
				this.selected
			);
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},
		changeFlag(item, color) {
			let url = 'items/update-flag';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getItems.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getItems[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		changeStatus(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItem({
					_id: item._id,
					id: item.id,
					is_active: item.is_active,
				}).then(() => {
					//this.total = result.total
					//this.items = result.data.data
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
						this.setPreload(false);
					});
					/*if (result.data.data.ok) {
                            this.snackbar.color = "success";
                            this.snackbar.text = "Update successfully";
                            this.snackbar.snackbar = true;
                            this.snackbar.mode = 'multi-line';
                            this.snackbar.timeout = 5000;
                        }*/
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},
		changeStatusVariant(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItemVariant({
					_id: item._id,
					id: item.id,
					variants: item.variants._id,
					active: item.variants.active,
				})
					.then(result => {
						//this.total = result.total
						//this.items = result.data.data
						if (result.data.data.ok) {
							this.snackbar.color = 'success';
							this.snackbar.text = 'Update successfully';
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
						}
					})
					.finally(el => {
						this.setPreload(false);
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async getCategoryMagento() {
			this.setPreload(true);
			await this.getFetchCategoryMagento();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Le categorie verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		/*async getItemsShopifyAz() {
			this.dialogconfirmImport = false;
			this.setPreload(true);
			await this.getItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'I prodotti saranno caricati in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},*/
		async duplicateItem(key) {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormDuplicate';
			let item;
			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			/* let item = _.find(this.getItems, search => {
                    return search._id == this.selected[0]
                })*/
			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			if (!item) return;
			this.setMessages();
			openWithReturn(this, { path: `/items/${item._id}/duplicate` }, { label: 'Torna ai riordini' });
		},
		async editItem(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});
			this.operation = 'FormEdit';

			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			if (!item) return;
			this.setMessages();
			openWithReturn(this, { path: `/items/${item._id}` }, { label: 'Torna ai riordini' });
		},
		async printItem(key) {
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			let variant_input = item.variants.variants.map(item => ({
				name: item.name._id,
				nameCmplete: {
					created_at: item.name.created_at,
					_id: item.name._id,
					trans: [{ _id: '63d0f0c0735985ed97e14937', lang: 'it', name: item.name.trans }],
					is_active: item.name.is_active,
					filter: item.name.filter,
				},
				value: item.value._id,
				valueComplete: {
					_id: item.value._id,
					trans: [{ _id: '63d0f0c0735985ed97e1493c', lang: 'it', name: item.value.trans }],
				},
				_id: item._id,
			}));

			if (item) {
				let url = `${this.getUrl}nocors/items/sku/print?token=${this.getToken}&sku=${item.variants.sku}&ean=${item.variants.ean}&variant=${JSON.stringify(variant_input)}&name=${
					item.trans?.name
				}&brand=${item.brand?._id}`;
				window.open(encodeURI(url), '_blank');
			}
		},
		// Unisci e' una pagina della variante: torna qui al termine
		joinItem(key) {
			const item = key || _.find(this.getItems, i => i._id === this.selected[0]);
			if (!item || !item._id || !item.variants) return;
			this.setItem(item);
			openWithReturn(this, { path: `/items/${item._id}/join`, query: { sku: item.variants.sku } }, { label: 'Torna ai riordini' });
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormCreate';
			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			this.setMessages();
			openWithReturn(this, { path: '/items/new' }, { label: 'Torna ai riordini' });
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async getFileCategories() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormFile';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		async getSearch() {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
			this.getDataFromApi();
		},

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);

				this.total = result.total;

				//this.items = result.data.data
				this.setPreload(false);
				this.selected = [];
				this.selectedall = [];
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    let response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},
		importItemConfirmShopify() {
			this.dialogconfirmImport = true;
		},
		async importNewItemShopify() {
			this.setPreload(true);

			await this.getNewItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Nuovi prodotti inseriti';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		confirmUpdateFromShopify() {
			this.dialogconfirmUpdate = true;
		},
		updateFromShopify(key) {
			this.messages = [];
			this.dialogconfirmUpdate = false;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			this.setPreload(true);

			this.updateSingleItemShopify(item)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
		},
		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},

		confirmDelete() {
			this.dialogconfirm = false;

			this.messages = [];
			let paypload = [];
			if (_.size(this.selected) > 0) {
				_.forEach(this.selected, cat => {
					let index = _.find(this.getItems, { _id: cat });

					if (index) {
						paypload.push(index);
					}
				});
			}
			if (this.form) {
				paypload.push(this.form);
			}
			this.deleteItems(paypload)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.reorder-cards,
.reorder-cards tr {
	display: block;
	width: 100%;
}
.reorder-cards tr,
.reorder-cards tr:hover {
	background: transparent !important;
}
.reorder-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.reorder-cards tr:first-child td {
	padding-top: 12px !important;
}
.reorder-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.reorder-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
.reorder-brand {
	font-size: 13px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.7);
}
</style>
